import * as React from 'react'
import { PageProps } from '@logic'
import { DashboardComponent } from '@modules/profile/components/dashboard-component'
import { signUpModal } from '@shared/components/modal'

type Props = PageProps

export const GuestDashboardPage = (props: Props) => {
    const { navigate } = props
    const signUpModalBundle = signUpModal({ navigate })

    return <>
        {signUpModalBundle.component}
        <DashboardComponent {...props} forGuest={true} openSignUp={() => signUpModalBundle.setVisible(true)} />
    </>
}
